import { PROYECT, api_get } from "services/api";

const baseUrl = process.env.REACT_APP_URL;

export const fetchWholesaleUnits = async (idCustomer) => {
  if (!idCustomer) return;
  const url = `${baseUrl}${PROYECT}/unit-wholesaler-customers/by-customer?idCustomer=${idCustomer}`;
  const data = await api_get(url);
  return data;
};

export const fetchUnitRetention = async (idUnit = "") => {
  try {
    if (!idUnit) return console.error("No idUnit in fetchUnitRetention")
    const url = `${baseUrl}${PROYECT}/unit-wholesaler-conditions?idUnit=${idUnit}`;
    const data = await api_get(url);
    return data;
  } catch (error) {
    console.error(error)
  }
}